import { Injectable, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { fromEvent } from 'rxjs';
import { debounceTime, filter, map } from 'rxjs/operators';
import { WINDOW } from '../window.service';

@Injectable({
  providedIn: 'root',
})
export class CrossTabAuthService {
  private _oidcService = inject(OidcSecurityService);
  private _window = inject(WINDOW);

  private _isAuthenticatedViaLocalStorage = computed(() => {
    const cvItem = this._storageSignal();
    if (cvItem === undefined) {
      return;
    }
    const id_token = cvItem?.authnResult?.id_token;
    const authzData = cvItem?.authzData;
    return !!id_token && !!authzData;
  });

  readonly showAuthOverlay = computed(() => {
    const isAuthenticated = this._oidcService.authenticated().isAuthenticated;
    const isLocalAuth = this._isAuthenticatedViaLocalStorage();

    console.debug('-- showAuthOverlay --\nisAuthenticated: ', isAuthenticated, '\nisLocalAuth: ', isLocalAuth);

    return isAuthenticated && isLocalAuth === false;
  });

  private _storageObservable$ = fromEvent(this._window, 'storage').pipe(
    filter((e) => e instanceof StorageEvent),
    filter(({ key, newValue }) => key === 'cv' && newValue !== null),
    debounceTime(100),
    map(({ newValue }) => JSON.parse(newValue!))
  );

  private _storageSignal = toSignal(this._storageObservable$);
}
